import React from 'react';
import './styles/styles.css';
import { BrowserRouter as Router, Route} from 'react-router-dom';

/* Start */
import Languages from './components/Languages';
import Home from './components/Home';
import Flashcards from './components/game/Flashcards';
import FlashcardsSingle from './components/game/FlashcardsSingle';
import Instructions from './components/game/GameInstructions';

/* Quiz */
import Quiz from './components/game/Quiz';
import Test from './components/game/Test';
import Video from './components/Video';

/* Timeline */
import TimelineSi from './components/game/TimelineSi';
import TimelineAu from './components/game/TimelineAu';
import TimelineExplainerSi from './components/game/TimelineExplainerSi';
import TimelineExplainerAu from './components/game/TimelineExplainerAu';

/* Results */
import Midgame from './components/game/Midgame';
import Results from './components/game/Results';

/* Manual */
import Manual from './components/game/Manual';

/* Single */
import Single from './components/game/Single';

function App() {
  return (
    <Router>
      <Route path="/" exact component={Languages} />
      <Route path="/home" exact component={Home} />
      <Route path="/play/instructions" exact component={Instructions} />
      <Route path="/play/teampicker" exact component={Flashcards} />
      <Route path="/play/singleplayer" exact component={FlashcardsSingle} />
      <Route path="/play/timeline/si" exact component={TimelineSi} />
      <Route path="/play/timeline/au" exact component={TimelineAu} />
      <Route path="/play/timeline/explainer/si" exact component={TimelineExplainerSi} />
      <Route path="/play/timeline/explainer/au" exact component={TimelineExplainerAu} />
      <Route path="/midgame" exact component={Midgame} />
      <Route path="/play/quiz" exact component={Quiz} />
      <Route path="/play/video" exact component={Video} />
      <Route path="/results" exact component={Results} />
      <Route path="/test" exact component={Test} />
      <Route path="/manual" exact component={Manual} />
      <Route path="/single" exact component={Single} />
      <Route path='/project' component={() => { 
       window.location.href = 'https://rmschools.isof.cnr.it'; 
      return null;
      }}/>
    </Router>

  )
  
}

export default App;
  